import { createSignal, Show } from 'solid-js'
import { userStore } from '/web/store/user'
import { aifansSubscriptionApi } from '/web/store/data/aifans-subscription'
import { toastStore } from '/web/store/toasts'

interface Props {
  show: boolean
  onClose: () => void
  imageId: string
  characterId: string
  modelName: string
}

const TipModal = (props: Props) => {
  const [tipAmount, setTipAmount] = createSignal('')
  const [sending, setSending] = createSignal(false)
  const [success, setSuccess] = createSignal(false)

  const handleSendTip = async () => {
    const amount = Number(tipAmount())
    if (!amount || amount <= 0) {
      toastStore.error(`Please enter a valid tip amount`)
      return
    }

    try {
      setSending(true)
      await aifansSubscriptionApi.sendTip(props.imageId, amount, props.characterId)
      setSuccess(true)
      // Wait 1.5 seconds before closing
      setTimeout(() => {
        setTipAmount('')
        props.onClose()
        setSuccess(false)
      }, 1500)
    } catch (err: any) {
      toastStore.error(err.message || 'Failed to send tip')
    } finally {
      setSending(false)
    }
  }

  return (
    <Show when={props.show}>
      <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        onClick={() => {
          setTipAmount('')
          props.onClose()
        }}
      >
        <div
          class="w-[300px] rounded-lg border border-white bg-[linear-gradient(45deg,#B14DFF_20%,#4A72FF_70%)] p-6 pt-3 md:w-[440px]"
          onClick={(e) => e.stopPropagation()}
        >
          <Show
            when={!success()}
            fallback={
              <div class="flex flex-col items-center justify-center py-8">
                <div class="mb-4 text-4xl">🎉</div>
                <h2 class="text-2xl font-semibold text-white">Thank You!</h2>
                <p class="mt-2 text-center text-white">
                  Successfully sent {tipAmount()} tokens to {props.modelName}
                </p>
              </div>
            }
          >
            <div class="relative">
              <h2 class="text-[32px] font-semibold text-white">Send A Tip</h2>
              <button
                onClick={() => {
                  setTipAmount('')
                  props.onClose()
                }}
                class="absolute -right-2 top-1 text-white"
              >
                <img src="/images/icons/close-round-x.png" class="h-[18px] w-[18px]" />
              </button>
            </div>

            <p class="my-4 text-sm font-semibold text-white md:text-lg">
              Show Your Appreciation For {props.modelName} By Sending A Tip:
            </p>

            <input
              type="number"
              value={tipAmount()}
              onInput={(e) => setTipAmount(e.currentTarget.value)}
              placeholder="Enter Your Token Tip Amount"
              class="mt-4 w-full rounded-lg border border-white bg-white/20 p-3 text-white placeholder:text-white/70"
            />

            <button
              onClick={handleSendTip}
              disabled={sending()}
              class="mt-4 w-full rounded-lg bg-[#8B5CF6] p-3 text-white hover:bg-[#7C3AED] disabled:opacity-50"
            >
              {sending() ? 'Sending...' : 'Send Tip'}
            </button>

            <button
              onClick={() => {
                userStore.buyTokensModal(true)
              }}
              class="mt-6 w-full text-center text-sm text-white/70"
            >
              Add Tokens
            </button>
          </Show>
        </div>
      </div>
    </Show>
  )
}

export default TipModal
